var map = {
	"./campaigns-selected.svg": "d258",
	"./campaigns.svg": "0c70",
	"./dashboard-selected.svg": "f22e",
	"./dashboard.svg": "9365",
	"./impact-selected.svg": "291c",
	"./impact.svg": "43fa",
	"./loans-selected.svg": "26d6",
	"./loans.svg": "757c",
	"./profile-selected.svg": "b8cd",
	"./profile.svg": "6bc9",
	"./projects-selected.svg": "58a3",
	"./projects.svg": "243d",
	"./settings-nav-selected.svg": "55d6",
	"./settings-nav.svg": "456a",
	"./settings.svg": "32ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1253";